export {
    isDevelopment,
    isB2B,
    API,
    APP_VERSION,
    DEFAULT_API_VERSION,
    DATE_FORMAT,
    DATE_TIME_FORMAT,
    DATE_FORMAT_DISPLAY,
    DATE_FORMAT_BACKEND_STRING,
    WEEKDAYS,
    ACCEPTED_FILES_IMAGE,
    locale,
} from '@starjack/utils';

export const LOCAL_STORAGE_KEY = 'starjackBackoffice';
export const LOCAL_STORAGE_KEY_AUTH = 'auth';
